export const escapeMixin = {
  methods: {
    escapePyString: function (value) {
      var single_quote = "'";
      var double_quote = '"';

      if (value.includes(single_quote)) {
        if (value.includes(double_quote) === false) {
          return double_quote + value + double_quote;
        }
        return single_quote + value.replace(/'/g, "\\'") + single_quote;
      } else {
        return single_quote + value + single_quote;
      }
    },
    escapeDoubleQuotes: function (value) {
      return value.replace(/"/g, '\\"');
    },
  },
};
